import { BiLogger } from '../../components/Hoc/BiLogger/BiLoggerProvider';
import { GetInitialPaymentData } from '../../types/ExternalContract';
import { transformPaymentBreakdownToApplePay } from './applePayDataMapper';

export const paymentMethodSelectedHandler =
  (
    cb: GetInitialPaymentData,
    data: { paymentLabel: string; appInstanceId: string; currencyCode: string },
    _biLogger: BiLogger,
  ) =>
  async (_event: ApplePayJS.ApplePayPaymentMethodSelectedEvent) => {
    try {
      const { paymentAmount, paymentBreakdown } = await cb();
      const newTotal = { label: data.paymentLabel, amount: paymentAmount };
      const newLineItems = transformPaymentBreakdownToApplePay(paymentBreakdown);

      return {
        newTotal,
        newLineItems,
      };
    } catch (e) {
      return e;
    }
  };
